/**
 * Created by chenzheyu on 2017/6/9.
 */
import XkWaiter from './src/waiter.vue'

XkWaiter.install = function (Vue) {
  Vue.component(XkWaiter.name, XkWaiter)
}

export default XkWaiter



// WEBPACK FOOTER //
// ./src/components/module/waiter/index.js